module.exports = __webpack_public_path__ + "static/media/PB_megafon.fcdd5e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PB_megafon.png
// module id = 228
// module chunks = 0